import { render } from "./area.vue?vue&type=template&id=220a076a"
import script from "./area.vue?vue&type=script&lang=js"
export * from "./area.vue?vue&type=script&lang=js"

import exportComponent from "/opt/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__